import { render, staticRenderFns } from "./EventItem2.vue?vue&type=template&id=d28db61c"
import script from "./EventItem2.vue?vue&type=script&lang=ts"
export * from "./EventItem2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports